// extracted by mini-css-extract-plugin
module.exports = {"svg":"_3xAas","bigSvg":"Y6M9P","rating":"_2gRQc"};